import { defineField } from 'sanity';

export const localizedString = defineField({
    name: 'localizedString',
    title: 'Localized String',
    type: 'object',
    fields: [
        {
            name: 'en',
            title: 'English',
            type: 'string',
        },
        {
            name: 'sr',
            title: 'Serbian',
            type: 'string',
        },
    ],
});
